import "react-phone-number-input/style.css";
import "./phone-input.css";
import ReactPhoneNumberInput, {
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTranslation } from "hooks/use-translation";

function PhoneInput({
  value,
  setValue,
  className,
  label,
  required = true,
  ...rest
}) {
  const { tcomponent, tcommon } = useTranslation({
    component: "phone-input",
  });

  const inputLabel = label || tcommon("phone-number");

  const error = value?.length > 0 && !isPossiblePhoneNumber(value ?? "");

  return (
    <div className={clsx("flex flex-col gap-4", className)}>
      <label className="group w-full flex flex-col gap-x-2 gap-y-2 xs:items-left xs:flex-col">
        <span className="xs:min-w-24">{inputLabel}</span>
        <ReactPhoneNumberInput
          {...rest}
          id="phone-number"
          international
          type="tel"
          name="phone-number"
          countryCallingCodeEditable={false}
          defaultCountry="GB"
          required={required}
          value={value}
          onChange={setValue}
        />
      </label>

      {error && (
        <span className="text-xs text-red-500">{tcomponent("error")}</span>
      )}
    </div>
  );
}

PhoneInput.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
};

export default PhoneInput;
